import moment from "moment";

export class NewTripSearch {
    constructor(obj: any = null) {
        if (obj) {
            this.origin = obj.origin || this.origin;
            this.destination = obj.destination || this.destination;
            this.departDate = moment(obj.departDate).toDate() || this.departDate;
            this.returnDate = moment(obj.returnDate).toDate() || this.returnDate;
            this.passengers = obj.passengers || this.passengers;
            this.currency = obj.currency || this.currency;
            this.carrierCode = obj.carrierCode || this.carrierCode;
            this.zipCode = obj.zipCode || this.zipCode;
        }
    }

    origin: String = "";
    destination: String = "";
    departDate: Date = null;
    returnDate: Date = null;
    passengers: Object = {
        adults: [], //array of strings representing pax ages
        children: [],
        infants: []
    };
    currency: String = "USD";
    carrierCode: String = "F9";
    zipCode: String = "";
}
